import React, { useState } from 'react';
import { View, Text } from 'react-native';

import {
  DownloadButton,
  downloadReport,
} from 'app/src/elements/ReportDownload';
import SearchableSelect from 'app/src/elements/SearchableSelect';
import { sellerOptions, buyerOptions } from './filterOptions';

import { cardStyles as styles } from './index';

const IfSalesReport = ({ data }) => {
  const [buyerId, setBuyerId] = useState();
  const [sellerId, setSellerId] = useState();

  const handleDownload = downloadProps => {
    downloadReport({
      ...downloadProps,
      path: 'if-sales-report',
      params: { 'buyer-id': buyerId, 'sellerId': sellerId }
    })
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>If Sales Report</Text>
      <Text style={styles.label}>Seller:</Text>
      <SearchableSelect
        placeholder="Select Seller"
        options={sellerOptions(data)}
        value={sellerId}
        onChange={setSellerId}
      />
      <Text style={styles.label}>Buyer:</Text>
      <SearchableSelect
        placeholder="Select Buyer"
        options={buyerOptions(data)}
        value={buyerId}
        onChange={setBuyerId}
      />
      <DownloadButton handleDownload={handleDownload} />
    </View>
  );
};

export default IfSalesReport;
